var _path, _circle, _circle2, _circle3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarScripts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V6C21 4.89543 20.1046 4 19 4H5ZM4.5 6C4.5 5.72386 4.72386 5.5 5 5.5H19C19.2761 5.5 19.5 5.72386 19.5 6V8.5H4.5V6ZM4.5 10H19.5V18C19.5 18.2761 19.2761 18.5 19 18.5H5C4.72386 18.5 4.5 18.2761 4.5 18V10Z",
    fill: "#111111"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.25,
    cy: 7,
    r: 0.65,
    fill: "#111111"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 7,
    r: 0.65,
    fill: "#111111"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.75,
    cy: 7,
    r: 0.65,
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.25L8.85 14L6.75 15.75",
    stroke: "#111111",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 16H15.25",
    stroke: "#111111",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarScripts);
export default __webpack_public_path__ + "static/media/navbar_scripts.acada6836895818c278853d9a0001009.svg";
export { ForwardRef as ReactComponent };